/**
 *
 * @param {string} name
 * @returns
 */

 import key from "./key"

 const url = `app/${key}`
 
 export const CREATE_FOLLOW_RECORD = `${url}/CREATE_FOLLOW_RECORD`
 export const CREATE_FOLLOW_RECORD_SUCCESS = `${url}/CREATE_FOLLOW_RECORD_SUCCESS`
 export const CREATE_FOLLOW_RECORD_ERROR = `${url}/CREATE_FOLLOW_RECORD_ERROR`
 
 export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
 export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
 export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`
 
 export const COMPANY_META_DATA = `${url}/COMPANY_META_DATA`
 export const COMPANY_META_DATA_SUCCESS = `${url}/COMPANY_META_DATA_SUCCESS`
 export const COMPANY_META_DATA_ERROR = `${url}/COMPANY_META_DATA_ERROR`
 
 
 export const LOAD_FOLLOWUP_DETAILS = `${url}/LOAD_FOLLOWUP_DETAILS`
 export const LOAD_FOLLOWUP_DETAILS_SUCCESS = `${url}/LOAD_FOLLOWUP_DETAILS_SUCCESS`
 export const LOAD_FOLLOWUP_DETAILS_ERROR = `${url}/LOAD_FOLLOWUP_DETAILS_ERROR`
 
 export const LOAD_REJECT_REASON_LIST = `${url}/LOAD_REJECT_REASON_LIST`
 export const LOAD_REJECT_REASON_LIST_SUCCESS = `${url}/LOAD_REJECT_REASON_LIST_SUCCESS`
 export const LOAD_REJECT_REASON_LIST_ERROR = `${url}/LOAD_REJECT_REASON_LIST_ERROR`



 export const UPDATE_FOLLOW_RECORD = `${url}/UPDATE_FOLLOW_RECORD`
 export const UPDATE_FOLLOW_RECORD_SUCCESS = `${url}/UPDATE_FOLLOW_RECORD_SUCCESS`
 export const UPDATE_FOLLOW_RECORD_ERROR = `${url}/UPDATE_FOLLOW_RECORD_ERROR`

 export const LOAD_RECORDS_FOLLOW_HISTORY_RECORD = `${url}/LOAD_RECORDS_FOLLOW_HISTORY_RECORD`
 export const LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS = `${url}/LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS`
 export const LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR = `${url}/LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR`

 export const LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD = `${url}/LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD`
 export const LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS = `${url}/LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS`
 export const LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR = `${url}/LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR`

 export const UPLOAD_FOLLOW_ATTACHMENT_RECORD = `${url}/UPLOAD_FOLLOW_ATTACHMENT_RECORD`
 export const UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS = `${url}/UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS`
 export const UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR = `${url}/UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR`

 export const FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD = `${url}/FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD`
 export const FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS = `${url}/FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS`
 export const FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR = `${url}/FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR`

 export const LOAD_RECORDS_VALID_CACHE =`${url}/LOAD_RECORDS_VALID_CACHE`

 export const ADD_REJECT = `${url}/ADD_REJECT`
 export const ADD_REJECT_SUCCESS = `${url}/ADD_REJECT_SUCCESS`
 export const ADD_REJECT_ERROR = `${url}/ADD_REJECT_ERROR`

 export const LOAD_FOLLOWUP_DETAILS_CRON = `${url}/LOAD_FOLLOWUP_DETAILS_CRON`
 export const LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS = `${url}/LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS`
 export const LOAD_FOLLOWUP_DETAILS_CRON_ERROR = `${url}/LOAD_FOLLOWUP_DETAILS_CRON_ERROR`

 export const LOAD_FOLLOWUP_HISTORY = `${url}/LOAD_FOLLOWUP_HISTORY`
 export const LOAD_FOLLOWUP_HISTORY_SUCCESS = `${url}/LOAD_FOLLOWUP_HISTORY_SUCCESS`
 export const LOAD_FOLLOWUP_HISTORY_ERROR = `${url}/LOAD_FOLLOWUP_HISTORY_ERROR`

 export const LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD = `${url}/LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD`
 export const LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS = `${url}/LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS`
 export const LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR = `${url}/LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR`

 
 const constants = {
   CREATE_FOLLOW_RECORD,
   CREATE_FOLLOW_RECORD_SUCCESS,
   CREATE_FOLLOW_RECORD_ERROR,
   LOAD_RECORDS_META_DATA,
   LOAD_RECORDS_META_DATA_ERROR,
   LOAD_RECORDS_META_DATA_SUCCESS,
   COMPANY_META_DATA,
   COMPANY_META_DATA_ERROR,
   COMPANY_META_DATA_SUCCESS,
   LOAD_RECORDS_FOLLOW_HISTORY_RECORD,
   LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS,
   LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR,
   LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
   LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS,
   LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR,
   UPLOAD_FOLLOW_ATTACHMENT_RECORD,
   UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
   UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
   FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD,
   FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
   FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
   LOAD_RECORDS_VALID_CACHE,

   ADD_REJECT,
   ADD_REJECT_SUCCESS,
   ADD_REJECT_ERROR,

   LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD,
   LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS,
   LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR,

   LOAD_FOLLOWUP_DETAILS_CRON,
   LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS,
   LOAD_FOLLOWUP_DETAILS_CRON_ERROR,

   LOAD_FOLLOWUP_DETAILS, 
   LOAD_FOLLOWUP_DETAILS_SUCCESS, 
   LOAD_FOLLOWUP_DETAILS_ERROR, 

   LOAD_REJECT_REASON_LIST, 
   LOAD_REJECT_REASON_LIST_SUCCESS, 
   LOAD_REJECT_REASON_LIST_ERROR, 
 }
 
 export default constants